module.exports = __webpack_public_path__ + "img/icon_distanceday_logo.10498ac0.png";